import { Box, LoadingOverlay } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'
import { useValidateToken } from '@/hooks/useValidateToken'
import { LinkExpiredHandler } from './LinkExpiredHandler'
import { SignUpFormHandler } from './SignUpFormHandler'

export const CompleteSignUpPage = () => {
  const { isTokenValid, token, email, uid, isPending } = useValidateToken()

  if (isPending) {
    return (
      <Box pos="relative" mih={200}>
        <LoadingOverlay visible={isPending} />
      </Box>
    )
  }

  if (!token || !uid) {
    return (
      <Box m="20px auto" maw={640}>
        <PlatformAlert variant="error" compact>
          <FormattedMessage id="inviteEmail.linkError" />
        </PlatformAlert>
      </Box>
    )
  }

  if (!isTokenValid) {
    return <LinkExpiredHandler uid={uid} token={token} />
  }

  if (isTokenValid && email) {
    return <SignUpFormHandler email={email} token={token} />
  }
}
